import { fetchAuthSession } from 'aws-amplify/auth'
import { axiosInstance } from '@/utils/axios'
import type { TypeFetcher } from '@/types/common/fetcher'
import { AxiosRequestConfig } from 'axios'

export const fetcher = async ({
  method,
  url,
  params,
  data,
  headerAppend,
}: TypeFetcher) => {
  const { tokens } = await fetchAuthSession()

  const config = {
    headers: {
      ...{
        Authorization: String(tokens?.idToken),
      },
      ...headerAppend,
    },
    method,
    url,
    data,
    params,
  } as AxiosRequestConfig // SWRのurlにnullを指定する為

  return axiosInstance(config)
    .then((res) => res.data)
    .catch((e) => {
      throw e
    })
}
